import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import axiosInstance from "../../../../api/axiosInstance";

const CopyTravelersDialog = ({ open, onClose, copyTravelers, user }) => {
  const [selectedSourceOrder, setSelectedSourceOrder] = useState(null);
  const [availableOrders, setAvailableOrders] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedTramo, setSelectedTramo] = useState("IDA");
  const [destinoTramo, setDestinoTramo] = useState("IDA");

  useEffect(() => {
    if (!open || searchText.trim().length < 2) return;

    const controller = new AbortController();

    const delay = setTimeout(() => {
      axiosInstance
        .get("/administration/service-orders/basic/search", {
          params: { search: searchText.trim() },
          signal: controller.signal,
        })
        .then((res) => setAvailableOrders(res.data || []))
        .catch((error) => {
          if (error.name !== "CanceledError") {
            console.error("Error al buscar órdenes:", error);
          }
        });
    }, 400);

    return () => {
      clearTimeout(delay);
      controller.abort();
    };
  }, [open, searchText]);

  const handleCopy = () => {
    if (!selectedSourceOrder) return;

    copyTravelers.mutate({
      origenOrdSerCabID: selectedSourceOrder.ordsercabid,
      tramo: selectedTramo,
      tramoDestino: destinoTramo,
      crebyid: user.EmpID,
    });

    onClose();
  };

  const handleClose = () => {
    setSelectedSourceOrder(null);
    setSearchText("");
    setSelectedTramo("IDA");
    setDestinoTramo("IDA");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Copiar pasajeros desde otra orden</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2} mt={1}>
          <Autocomplete
            options={availableOrders}
            value={selectedSourceOrder}
            onInputChange={(event, value) => setSearchText(value)}
            onChange={(event, value) => setSelectedSourceOrder(value)}
            getOptionLabel={(option) =>
              option
                ? `OS-${String(option.ordsercabid).padStart(6, "0")} - ${
                    option.ordsercabnom
                  }`
                : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Orden de servicio anterior"
                placeholder="Buscar por código, nombre o proyecto"
              />
            )}
          />

          <Box display="flex" gap={2}>
            <TextField
              select
              fullWidth
              label="Tramo origen"
              value={selectedTramo}
              onChange={(e) => setSelectedTramo(e.target.value)}
            >
              <MenuItem value="IDA">SUBIDA</MenuItem>
              <MenuItem value="VUELTA">BAJADA</MenuItem>
            </TextField>

            <TextField
              select
              fullWidth
              label="Tramo destino"
              value={destinoTramo}
              onChange={(e) => setDestinoTramo(e.target.value)}
            >
              <MenuItem value="IDA">SUBIDA</MenuItem>
              <MenuItem value="VUELTA">BAJADA</MenuItem>
            </TextField>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleCopy}
          disabled={!selectedSourceOrder || copyTravelers.isLoading}
        >
          Copiar pasajeros
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopyTravelersDialog;